module.exports = __webpack_public_path__ + "img/logo.a1d946ca.png";